import { render, staticRenderFns } from "./FeeSplit.vue?vue&type=template&id=57935ee6&scoped=true&"
import script from "./FeeSplit.vue?vue&type=script&lang=js&"
export * from "./FeeSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57935ee6",
  null
  
)

export default component.exports